/**
 * Merkt sich, ob zuletzt per Tastatur oder Maus/Touch bedient wurde (.is-keyboardNav am
 * <html>). Grund: Textfelder matchen :focus-visible laut Browser-Spezifikation IMMER,
 * auch beim Mausklick - der Fokus-Rahmen (base/_a11y.scss) soll dort aber nur bei
 * Tastaturbedienung erscheinen.
 */
const KEYBOARD_CLASS = 'is-keyboardNav';
const root = document.documentElement;

document.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') root.classList.add(KEYBOARD_CLASS);
}, true);

document.addEventListener('pointerdown', () => {
    root.classList.remove(KEYBOARD_CLASS);
}, true);
